<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'details' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="modal-content">
    <div class="top-section">
      <div class="ratingbar-list" *ngIf="this.selCountry != 'Frankreich'">
        <div *ngFor="let rating of energyRatings" [class]="'ratingbar-item ' + getRatingClass(rating.grade)">

          <div [ngClass]="isSelected(rating.id) ? 'selectedRating' : 'unselectedRating'"
            [style.border-color]="isSelected(rating.id) ? rating.color : 'transparent'">
            <div class="leftData" [style.background-color]="rating.color" [style.min-width]="rating.minWidth"
              [class.dark-text]="rating.isDarkText">
              <div class="ratingbar-range" [innerHTML]="rating.range"></div>
              <!-- <div class="ratingbar-range">{{rating.range}}</div> -->
              <div class="ratingbar-grade">{{rating.grade}}</div>
            </div>
          </div>

          <div class="line-container" *ngIf="isSelected(rating.id)">
            <div class="connecting-line"></div>
          </div>

          <div class="rightData" *ngIf="isSelected(rating.id)" [style.border-color]="rating.color">
            {{energyValue}}
          </div>
        </div>
      </div>

      <div class="energy-label-container" *ngIf="this.selCountry == 'Frankreich'">
        <!-- Zones climatiques section -->
        <div class="section">
          <ion-row class="header-section">
            <ion-col size="auto" class="image-col">
              <div class="image-container">
                <ion-img src="assets/images/werlabel/fr/zones.png" alt="Product Image" class="product-image">
                </ion-img>
              </div>
            </ion-col>

            <ion-col class="title-col">
              <div class="titles-container">
                <h6>{{'WER_FR_TITLE' |translate}}</h6>
                <h6>{{'WER_FR_SUBTITLE' | translate}}</h6>
              </div>
            </ion-col>
          </ion-row>

          <div class="zones-table-container">
            <table class="zones-table">
              <thead>
                <tr>
                  <th style="width: 50%; background: none; border: none;"></th>
                  <th>Z1</th>
                  <th>Z2</th>
                  <th>Z3</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of zonesRows">
                  <td [ngClass]="'grade-' + row.label"><strong>{{row.label}}</strong></td>
                  <td>{{row.z1}}</td>
                  <td>{{row.z2}}</td>
                  <td>{{row.z3}}</td>
                </tr>
                <tr>
                  <td class="energy-scale">
                    <div *ngFor="let grade of energyGrades" class="grade" [ngClass]="'confort-dete-' + grade">
                      {{grade}}
                    </div>
                  </td>
                  <td>{{result.badgeConfortZ1}}</td>
                  <td>{{result.badgeConfortZ2}}</td>
                  <td>{{result.badgeConfortZ3}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>

    <div class="bottom-section">
      <div class="metrics-container" *ngIf="this.selCountry == 'Schweiz'">

        <div class="metric-item">
          <div class="metric-label">{{'climate_zone' |translate}}</div>
          <div class="metric-value">Swiss</div>
        </div>
      </div>
      <div class="metrics-container" *ngIf="this.selCountry == 'Frankreich'">
        <div class="metric-item">
          <div class="metric-label">{{'WER_FR_HEADER_TRANS_THERMIQUE' | translate}}</div>
          <div class="metric-value"></div>
        </div>
        <div class="metric-item">
          <div class="metric-label">{{'WER_FR_HEADER_SOLAIRE' |translate}}</div>
          <div class="metric-value">{{result.sw}}</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">{{'HEADER_LIGHT_TRANS' | translate}}</div>
          <div class="metric-value">{{result.tLw}}%</div>
        </div>
      </div>

      <div class="metrics-container" *ngIf="this.selCountry == 'Dänemark'">

        <div class="metric-item">
          <div class="metric-label">A<sub>g</sub></div>
          <div class="metric-value">{{result.areaGlass}}m²</div>
        </div>

        <div class="metric-item">
          <div class="metric-label">A<sub>w</sub></div>
          <div class="metric-value">{{result.areaWindow}}m²</div>
        </div>

        <div class="metric-item">
          <div class="metric-label">g<sub>w</sub></div>
          <div class="metric-value">{{result.gw}}</div>
        </div>

        <div class="metric-item">
          <div class="metric-label">E<sub>ref</sub></div>
          <div class="metric-value">{{result.eref}}kWh/m²a</div>
        </div>
      </div>
      <div class="metrics-container" *ngIf="this.selCountry == 'Großbritannien'">

        <div class="metric-item">
          <div class="metric-label">{{'climate_zone' |translate}}</div>
          <div class="metric-value">UK</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">Solar factor (gw):</div>
          <div class="metric-value">{{result.gw}} W/m²K</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">Window air leakage heat loss:</div>
          <div class="metric-value">{{result.lfac}} W/m²K</div>
        </div>
      </div>
      <div class="metrics-container" *ngIf="this.selCountry == 'Other'">

        <div class="metric-item">
          <div class="metric-label">Ψ<sub>opak</sub>:</div>
          <div class="metric-value">{{result.psiOpaque}}W/mK</div>
        </div>
        <div class="metric-item">
          <div class="metric-label">U<sub>w</sub> PHI:</div>
          <div class="metric-value">{{result.uwPhi}}W/m²K</div>
        </div>
      </div>
    </div>
  </div>
</ion-content>